module.exports = __webpack_public_path__ + "10cebe489552ca180e780748d77a8337.svg";